module.exports = flarum.reg.get('core', 'common/utils/extractText');